import { render, staticRenderFns } from "./UserGroupDetail.vue?vue&type=template&id=9cf3b3c8&scoped=true&"
import script from "./UserGroupDetail.vue?vue&type=script&lang=js&"
export * from "./UserGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupDetail.vue?vue&type=style&index=0&id=9cf3b3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf3b3c8",
  null
  
)

export default component.exports